import { render, staticRenderFns } from "./plugin-card.vue?vue&type=template&id=106b186c&scoped=true&"
import script from "./plugin-card.vue?vue&type=script&lang=js&"
export * from "./plugin-card.vue?vue&type=script&lang=js&"
import style0 from "./plugin-card.vue?vue&type=style&index=0&id=106b186c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b186c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LazyLoad: require('/builds/master/frontend/frontend-universe/components/lazy-load.vue').default,SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
